<template>
  <div class="plays">
    <md-table v-if="$store.state.pageLoaded" md-sort="title" v-model="$store.state.receivedData.plays.list" class="plays-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyPlay))" title="Dodaj pozornicu" v-if="$store.state.schema.play.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Predstave</h1>
        </div>
      </md-table-toolbar>

      <md-table-row md-selectable="single" md-auto-select slot="md-table-row" slot-scope="{ item }" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell md-sort-by="title" md-label="Naziv">{{ item.title }}</md-table-cell>
        <md-table-cell md-sort-by="short_title" md-label="Kratki naziv">{{ item.short_title }}</md-table-cell>
        <md-table-cell md-sort-by="author" md-label="Autor predstave">{{ item.author }}</md-table-cell>
        <md-table-cell md-sort-by="kind" md-label="Ansambl">{{ getAnsembleName(item.kind) }}</md-table-cell>
        <md-table-cell md-sort-by="organization_unit" md-label="Organizacijska jedinica">{{ item.organization_unit }}</md-table-cell>
        <md-table-cell md-sort-by="cost_center" md-label="Mjesto troška">{{ item.cost_center }}</md-table-cell>
        <md-table-cell md-sort-by="note" md-label="Napomena">{{ item.note }}</md-table-cell>
        <md-table-cell md-label="Akcije" class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši" v-if="$store.state.schema.play.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi" v-if="$store.state.schema.play.update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje predstave"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Naziv</label>
              <md-input required type="text" v-model="$store.state.selectedObject.title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('short_title', $store.state.selectedObject)">
              <label>Kratki naziv</label>
              <md-input required type="text" v-model="$store.state.selectedObject.short_title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('author', $store.state.selectedObject)">
              <label>Autor predstave</label>
              <md-input required type="text" v-model="$store.state.selectedObject.author"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('kind', $store.state.selectedObject)">
              <label>Ansambl</label>
              <md-select v-model="$store.state.selectedObject.kind">
                <md-option v-for="value, key in $store.state.ansemble" :value="key">{{ value }}</md-option>
              </md-select>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('organization_unit', $store.state.selectedObject)">
              <label>Organizacijska jedinica</label>
              <md-input type="text" v-model="$store.state.selectedObject.organization_unit"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('cost_center', $store.state.selectedObject)">
              <label>Mjesto troška</label>
              <md-input type="text" v-model="$store.state.selectedObject.cost_center"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field>
              <label>Napomena</label>
              <md-input type="text" v-model="$store.state.selectedObject.note"/>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'

export default {
  name: 'Plays',
  data(){
    return {
      emptyPlay: {
        title: '',
        short_title: '',
        author: '',
        kind: '1',
        organization_unit: '',
        cost_center: '',
        note: '',
      },
      requiredFields: ['title', 'short_title', 'author', 'ansemble', 'organization_unit', 'cost_center'],
    }
  },

  mixins: [ListingMixin('plays', 'predstavu')],

  methods: {
    getAnsembleName(key){
      return this.$store.state.ansemble[key];
    },
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Plays.vue